export function RivalryCollectorIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 24l14-16 14 16-14 16z" />
      <line x1="16" y1="24" x2="32" y2="24" />
      <line x1="24" y1="14" x2="24" y2="34" />
    </svg>
  );
}
